import { Product } from './product';

export const MOCKPRODUCTS: Product[] = [
  {
    title: 'Building/ Spaces',
    icon: 'fa fa-building',
    // tslint:disable-next-line:max-line-length
    imageToday: 'https://www.nasa.gov/images/content/628347main_midtown_manhattan_670.jpg',
    imageTomorrow: 'http://www.asiagreenbuildings.com/wp-content/uploads/2015/02/A-computer-generated-image-of-city-buildings-with-green-roofs-copy.jpg',
    category: 'catalyst',
    today: 'Husqvarna products are used in city parks and public green spaces.',
    tomorrow: 'Husqvarna will become an active contributor in creating green spaces.',
    next: 'next',
  }, {
    title: 'Lifestyle',
    icon: 'fa fa-heart',
    imageToday: 'http://ekologo.pl/wp-content/uploads/2017/03/sposoby-usprawnienia-pracy-na-roli.jpg',
    imageTomorrow: 'http://www.traineeguiden.se/uploads/media/general_image/0001/01/husqvarna-img4_general_image_wide.jpeg',
    category: 'catalyst',
    today: 'In particular home owners spend a lot of time mowing their lawns and worrying about the upkeep of lawns.',
    tomorrow: 'Husqvarna makes products that allow home owners to spend their free time socializing with their family and friends.',
    next: 'next',
  }
];



// WEBPACK FOOTER //
// /Users/Myrberg/Documents/spring_repo1/spring-app/src/app/base/components/canvas/components/business-areas/products/mock-products.ts